export class Version {
  static readonly id = '5.0.5';
  static readonly experimental = false;
}
